export default __webpack_public_path__ + "0fd3ce37a3f25dc175fb0bf3c82cf334.png";